import { loadJson, saveJson } from '@/features/kitchen/storage/persist'

export const DISPATCH_STORAGE_KEY = 'superoti.kitchen.dispatch'

export type ShipmentStatus = 'draft' | 'prepared' | 'in_transit' | 'received'

export type ShipmentLineRecord = {
  id: string
  productName: string
  productionDate: string
  qty: number
}

export type ShipmentRecord = {
  id: string
  storeName: string
  delmanName: string
  /** YYYY-MM-DD tanggal kirim (trip_date) */
  tripDate?: string
  status: ShipmentStatus
  lines: ShipmentLineRecord[]
  updatedAt: string
}

export const DEFAULT_DISPATCH_SHIPMENTS: ShipmentRecord[] = [
  {
    id: 'DLV-20260623-01',
    storeName: 'Toko Menteng',
    delmanName: 'Budi Santoso',
    status: 'prepared',
    updatedAt: 'Disiapkan dapur 07:45',
    lines: [
      { id: 'l1', productName: 'Roti coklat', productionDate: '23/06/26', qty: 30 },
      { id: 'l2', productName: 'Donat gula', productionDate: '23/06/26', qty: 20 },
    ],
  },
  {
    id: 'DLV-20260623-02',
    storeName: 'Toko Kemang',
    delmanName: 'Budi Santoso',
    status: 'prepared',
    updatedAt: 'Disiapkan dapur 08:00',
    lines: [
      { id: 'l4', productName: 'Roti coklat', productionDate: '23/06/26', qty: 50 },
      { id: 'l5', productName: 'Donat meses', productionDate: '23/06/26', qty: 30 },
    ],
  },
  {
    id: 'DLV-20260623-03',
    storeName: 'Toko Cipete',
    delmanName: 'Budi Santoso',
    status: 'prepared',
    updatedAt: 'Disiapkan dapur 08:15',
    lines: [
      { id: 'l6', productName: 'Roti keju', productionDate: '23/06/26', qty: 20 },
      { id: 'l7', productName: 'Roti coklat', productionDate: '22/06/26', qty: 15 },
    ],
  },
  {
    id: 'DLV-20260623-04',
    storeName: 'Toko Senayan',
    delmanName: 'Andi Wijaya',
    status: 'received',
    updatedAt: 'Toko terima 22/06 16:10',
    lines: [
      { id: 'l8', productName: 'Roti coklat', productionDate: '22/06/26', qty: 30 },
      { id: 'l9', productName: 'Donat gula', productionDate: '22/06/26', qty: 0 },
    ],
  },
]

export function loadDispatchShipments(): ShipmentRecord[] {
  return loadJson<ShipmentRecord[]>(DISPATCH_STORAGE_KEY) ?? DEFAULT_DISPATCH_SHIPMENTS
}

export function saveDispatchShipments(shipments: ShipmentRecord[]): void {
  saveJson(DISPATCH_STORAGE_KEY, shipments)
}

export function getDispatchSummary() {
  const shipments = loadDispatchShipments()
  const pending = shipments.filter((s) => s.status === 'draft' || s.status === 'prepared')
  const inTransit = shipments.filter((s) => s.status === 'in_transit')
  const prepared = shipments.filter((s) => s.status === 'prepared')

  return {
    pendingCount: pending.length,
    preparedCount: prepared.length,
    inTransitCount: inTransit.length,
    pendingStores: pending.map((s) => s.storeName),
  }
}
